import { render, staticRenderFns } from "./OostendeView.vue?vue&type=template&id=65ef8b9f&"
import script from "./OostendeView.vue?vue&type=script&lang=js&"
export * from "./OostendeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports